<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">edit</i>
                        </div>
                        <h4 class="card-title ">Editar</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'type_of_payments.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            form() {
                return this.$store.state.type_of_payments.item;
            }
        },
        created() {
            this.getData();
        },
        data() {
            return {
                validation: {
                    name: ''
                }
            };
        },
        methods: {
            onSubmit(_ev) {
                var valid = true;
                var self = this;

                self.validation.name = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');
                    
                    const response = self.$store.dispatch('type_of_payments/edit', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Tipo de pagamento atualizado com sucesso!");
                        self.$router.push({'name': 'type_of_payments.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }
                        }
                    });
                }
                
                _ev.preventDefault();
            },
            async getData() {
                var self = this;
                
                self.$root.$emit('onLoading');
                
                const response = self.$store.dispatch('type_of_payments/get', this.$route.params.id);
                
                response.then(function(){
                    self.$root.$emit('onLoading');
                });
                
                response.catch(function(){
                    self.$root.$emit('onLoading');
                    self.$router.push({'name': 'type_of_payments.index'});
                });
            }
        }
    };
</script>